import { render, staticRenderFns } from "./ActivityGeneralTest.vue?vue&type=template&id=5f732815&"
import script from "./ActivityGeneralTest.vue?vue&type=script&lang=js&"
export * from "./ActivityGeneralTest.vue?vue&type=script&lang=js&"
import style0 from "./ActivityGeneralTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ActivityGeneralTest.vue"
export default component.exports